<template>
    <div class="about container pt-lg-5">
        <videoCall ref="webrtc" width="100%" roomId="sample-room">
        </videoCall>
    </div>
</template>


<script>
    export default {
        name: 'AboutPage',
        mounted() {
            this.$store.state.filter = false
            this.$store.state.runAnimation = false
        },
    }
    
</script>